// extracted by mini-css-extract-plugin
module.exports = {"anomaly":"styles_anomaly__37nQB"};